import { EditOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import EnableDisableButton from "components/Shared/EnableDisableButton";
import { CrossDockingDetailContext, useCrossDockingDetailContext } from "contexts/CrossDockingDetailContext";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from 'react'
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetCrossDockingDetailQuery, useUpdateCrossDockingMutation } from "store/services/crossDockingApi";
import CrossDockingBasicDetail from "./CrossDockingComponents/CrossDockingBasicDetail";
import { useAuth } from "hooks";

const CrossDockingDetailScreen = () => {


  const { id } = useParams();

  const breadcrumb = [
    { title: "Cross Docking", path: "/app/crm/cross-docking/list" },
    { title: "Cross Docking Detail" }
  ]

  // RTK Query
  const {
    data: crossDockingDetail,
    isLoading: loadingCrossDocking,
    error,
  } = useGetCrossDockingDetailQuery(id);

  return (
    <CrossDockingDetailContext.Provider value={{ crossDockingDetail, loadingCrossDocking }}>
      <BreadcrumbLayout breadcrumbs={breadcrumb}
        isBusy={loadingCrossDocking}
        headerActions={<PageActions />} >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <CrossDockingBasicDetail />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </CrossDockingDetailContext.Provider>
  )
}

export default CrossDockingDetailScreen;

const PageActions = () => {

  const { isAccountAdmin } = useAuth();

  const { crossDockingDetail, loadingCrossDocking }
    = useCrossDockingDetailContext();

  // RTK Query
  const [updateCrossDocking, { isLoading: updatingCrossDocking }]
    = useUpdateCrossDockingMutation();

  // methods
  const handelToggleCrossDockingStatus = async () => {
    try {
      await updateCrossDocking({
        _id: crossDockingDetail._id,
        isActive: !crossDockingDetail.isActive,
      }).unwrap();
      toast.info(`CrossDocking ${crossDockingDetail.isActive ? "Disable" : "Enable"} !`);
    } catch (error) {
      toast.error(error?.data.message ?? "Could Not Update Status");
    }
  }

  return (
    <div className="flex space-x-4">
      {isAccountAdmin && (<EnableDisableButton
        isActive={crossDockingDetail?.isActive}
        loading={loadingCrossDocking || updatingCrossDocking}
        onClick={handelToggleCrossDockingStatus}
      />)}
      <Link to={`/app/crm/cross-docking/${crossDockingDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};